function waitTimeout(cb: () => void, ms: number) {
  return new Promise(resolve => {
    setTimeout(() => {
      cb();
      resolve();
    }, ms);
  });
}

export async function mockStream(text: string, cb: (textToStream: string) => void) {
  let textToStream = text;
  while (textToStream.length > 0) {
    const callback = () => {
      const skip = Math.round(Math.random() * 200) + 1;
      let nextIndex = textToStream.substring(skip).indexOf(' ') + skip;
      if (nextIndex <= 0) nextIndex = 24;

      cb(textToStream.slice(0, nextIndex));
      textToStream = textToStream.slice(nextIndex);
    };

    await waitTimeout(callback, Math.random() * 200);
  }
}
